var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { deserialize, withDefault } from '../../../../utils/serializr/serializr';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { editable } from '../../../../utils/mobx/decorators/editable';
export class TimeMark {
    type = 'timemark';
    parent;
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
    }
    get ply() {
        return this.parent;
    }
    markTime;
    markName;
    static fromSerialized(ser = {}) {
        return deserialize(TimeMark, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                markTime: withDefault(primitive, 0),
                markName: withDefault(primitive, 'Neue Marke'),
            },
        };
    }
}
__decorate([
    editable()
], TimeMark.prototype, "markTime", void 0);
__decorate([
    editable()
], TimeMark.prototype, "markName", void 0);
__decorate([
    memoize
], TimeMark, "serializeInfo", null);
